import { AppointmentsForServiceProvider } from './getAppointmentsForServiceProvider';
import dayjs from 'dayjs';

type appointment = AppointmentsForServiceProvider[number]
type getAppointmentsForPlaceAndDateAppointments = (
  {
    location: Pick<appointment['location'], 'placeId'>;
    startDateTime: appointment['startDateTime'];
  }
)[]

export const getAppointmentsForPlaceAndDate = (
  appointments: getAppointmentsForPlaceAndDateAppointments,
  placeId: string,
  now: number,
) => {
  const nowDayjs = dayjs.unix(now);

  const matches = appointments.filter(
    a => {
      const isSameLocation = a.location.placeId === placeId;
      const isSameDay =
        dayjs.unix(a.startDateTime).isSame(nowDayjs, 'd');

      if (isSameLocation && isSameDay) {
        return true;
      }
    }
  );

  return matches;
};

export const selectStartDateTimeGetInitialStartDateTime = (
  now: number,
  bookingCartStartDateTime: number | undefined,
  recommendedStartDateTime: number | null,
) => {
  if (recommendedStartDateTime && recommendedStartDateTime > now) {
    // round recommendedStartDateTime to the nearest 30 minutes
    return recommendedStartDateTime - (recommendedStartDateTime % 1800);
  }

  if (!bookingCartStartDateTime) {
    return undefined;
  }

  if (bookingCartStartDateTime > now) {
    return bookingCartStartDateTime;
  }

  return undefined;
};

